<template>
  <v-container
    class="distribution-spesfiic-container standard-content-container"
  >
    <v-row no-gutters>
      <v-col cols="12" md="5">
        <v-row no-gutters class="title-section">
          <v-col
            cols="12"
            sm="2"
            class="link-container"
            :class="{
              'small-container':
                this.$vuetify.breakpoint.width <=
                this.$vuetify.breakpoint.thresholds.xs,
            }"
          >
            <router-link
              :to="{ name: 'RemainderOfEstateDistribution', hash: '' }"
              class="back-arrow"
              ><v-icon large color="mid-grey" class="mt-1">{{
                icons.mdiArrowLeft
              }}</v-icon></router-link
            >
          </v-col>
          <v-col cols="12" sm="10" class="standard-content-container">
            <h1>Remainder of Estate</h1>
            <p>
              Add the beneficiares of the remainder of your estate here and
              specify a percentage that each should get with the total
              percentages adding up to 100%
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="7">
        <div class="left-section-container">
          <AssignSpecificPercentages
            :testator="testator"
            :existing-specific-percentages="existingSpecificPercentages"
            :button-loading="buttonLoading"
            @submit="submit"
          />
        </div>
      </v-col>
    </v-row>

    <ErrorSnackbar v-model="showError" />
  </v-container>
</template>

<script>
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import { PROCESS_DISTRIBUTION_SPECIFIC_PERCENTAGES_MUTATION } from '../../constants/graphql/remainder-of-estates';
  import AssignSpecificPercentages from './AssignSpecificPercentages';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'DistributionSpecificPercentages',
    components: {
      AssignSpecificPercentages,
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        type: Object,
        required: true,
      },
    },
    computed: {
      existingSpecificPercentages() {
        return this.testator.remainderOfEstate
          ? this.testator.remainderOfEstate.distributionSpecificPercentages
          : [];
      },
    },
    created() {
      if (
        !this.testator.remainderOfEstate ||
        this.testator.remainderOfEstate.distribution != 'SPECIFIC_PERCENTAGES'
      ) {
        this.$router.push('distribution');
      }
    },
    methods: {
      submit({ specificPercentages, deletedRecordIds }) {
        if (this.buttonLoading) return;
        this.buttonLoading = true;
        this.saveSpecificPercentages(specificPercentages, deletedRecordIds);
      },
      saveSpecificPercentages(specificPercentages, deletedRecordIds) {
        const distributionSpecificPercentageInputs =
          this.specificPercentagesForMutation(specificPercentages);

        this.$apollo
          .mutate({
            mutation: PROCESS_DISTRIBUTION_SPECIFIC_PERCENTAGES_MUTATION,
            variables: {
              distributionSpecificPercentageInputs,
              deletedRecordIds,
            },
            update: (
              cache,
              { data: { processDistributionSpecificPercentages } }
            ) => {
              this.updateCacheAfterSpecificPercentages(
                cache,
                processDistributionSpecificPercentages
              );
            },
          })
          .then(_response => {
            this.redirectToNext(specificPercentages);
            this.buttonLoading = false;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      specificPercentagesForMutation(specificPercentages) {
        var specificPercentageInputs = [];
        for (const sp of specificPercentages) {
          var specificPercentageInput = {};
          specificPercentageInput.id = sp.id;
          specificPercentageInput.beneficiaryType = sp.beneficiaryType;
          specificPercentageInput.beneficiaryId = sp.beneficiaryId;
          specificPercentageInput.percentage = parseInt(sp.percentage);
          specificPercentageInput.remainderOfEstateId =
            this.testator.remainderOfEstate.id;

          specificPercentageInputs.push(specificPercentageInput);
        }

        return specificPercentageInputs;
      },
      updateCacheAfterSpecificPercentages(
        cache,
        processDistributionSpecificPercentages
      ) {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: this.testatorId },
        };
        const data = cache.readQuery(query);

        data.testator.remainderOfEstate.distributionSpecificPercentages =
          processDistributionSpecificPercentages;

        cache.writeQuery({ ...query, data: data });
      },
      redirectToNext(specificPercentages) {
        const hasPersonSpecificPercentage = specificPercentages.find(
          sp => sp.beneficiaryType == 'Person'
        );
        if (hasPersonSpecificPercentage) {
          this.$router.push('distribution-specific-percentage-alternative/1');
        } else {
          this.$router.push({ name: 'FamilyObliteration' });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .distribution-spesfiic-container {
    padding-top: 28px;
    padding-bottom: 48px;

    .remainder-title {
      line-height: 36px;
    }
  }
  .distribution-spesfiic-container.small-distr-container {
    padding: 0;
    padding-top: 28px;
  }
</style>
